import { SvgIcon } from '@mui/material';
import StadiumIcon from '@mui/icons-material/Stadium';
import {
  mdiGuitarAcoustic,
  mdiGuitarElectric,
  mdiAmplifier,
  mdiMicrophone,
  mdiPiano,
  mdiCog,
  mdiSurroundSound,
  mdiMusicNote,
  mdiSpeaker,
  mdiViolin
} from '@mdi/js';
import i18n from './i18n';
import { useTranslation } from 'react-i18next';

// This function can be used outside of React components by importing i18n directly
export const getGearLabel = (key: string): string => {
  if (!key) return '';
  return (i18n.t as any)(`gears.${key}`, key);
};

// For React components, use this hook-based version which will update when language changes
export const useGearLabel = () => {
  const { t } = useTranslation();
  return (key: string) => {
    if (!key) return '';
    return (t as any)(`gears.${key}`, key);
  };
};

export const MdiIcon = ({ path }: { path: string }) => (
  <SvgIcon fontSize="small">
    <path d={path} />
  </SvgIcon>
);

export const gearIcons: Record<string, JSX.Element> = {
  GUITAR: <MdiIcon path={mdiGuitarAcoustic} />,
  BASS_GUITAR: <MdiIcon path={mdiGuitarElectric} />,
  GUITAR_AMP: <MdiIcon path={mdiAmplifier} />,
  BASS_AMP: <MdiIcon path={mdiSurroundSound} />,
  DRUM_KIT: <StadiumIcon />,
  MICROPHONE: <MdiIcon path={mdiMicrophone} />,
  KEYBOARD: <MdiIcon path={mdiPiano} />,
  MIXER: <MdiIcon path={mdiMusicNote} />,
  SPEAKERS: <MdiIcon path={mdiSpeaker} />,
  VIOLIN: <MdiIcon path={mdiViolin} />,
  CUSTOM: <MdiIcon path={mdiCog} />,
};